import { t } from "@lingui/macro";


const CONTENT_TYPE_FORM_CONSTANT_LIVE_ENABLE = [
	{
		key: "VOD",
		label: t({
			id: "fc-vod",
			message: "Video On Demand"
		})
	},
	{
		key: "LIVE",
		label: t({
			id: "fc-live",
			message: "Diretta"
		})
	}
];

const CONTENT_TYPE_FORM_CONSTANT_LIVE_DISABLE = [
	{
		key: "VOD",
		label: t({
			id: "fc-vod",
			message: "Video On Demand"
		})
	}
];

export const CONTENT_TYPE_FORM_CONSTANT = process.env.REACT_APP_LIVE_ENABLED === "true" ? CONTENT_TYPE_FORM_CONSTANT_LIVE_ENABLE : CONTENT_TYPE_FORM_CONSTANT_LIVE_DISABLE

export const AUDIENCE = [
	{
		key: "RELEASED",
		label: t({
			id: "const-aud-rel",
			message: "Rilasciato"
		})
	},
	{
		key: "UNRELEASED",
		label: t({
			id: "const-aud-unrel",
			message: "Non rilasciato"
		})
	}
];

export enum ContentType {
	VOD = "VOD",
	LIVE = "LIVE"
}

export enum SegregationType {

	PAY_PER_VIEW = "PAY_PER_VIEW",
	SUBSCRIPTION = "SUBSCRIPTION",
	REGISTERED = "REGISTERED",
	FREE = "FREE",
	FOLLOW_SERIES = "FOLLOW_SERIES"
}

export const CURRENCY_CONSTANT = [
	{
		key: "EUR",
		label: t({
			id: "const-cc-eur",
			message: "Euro"
		})
	},
	{
		key: "USD",
		label: t({
			id: "const-cc-usd",
			message: "Dollari"
		})
	},

	{
		key: "CHF",
		label: t({
			id: "const-cc-chf",
			message: "Franchi Svizzeri"
		})
	},
]

export const SEGREGATION_TYPE_FORM_CONSTANT = [
	{
		key: "FREE",
		label: t({
			id: "const-stfc-free",
			message: "Gratuita - No registrazione"
		})
	},
	{
		key: "PAY_PER_VIEW",
		label: t({
			id: "const-stfc-ppv",
			message: "Pay Per View"
		})
	},
	{
		key: "REGISTRATION",
		label: t({
			id: "const-stfc-registration",
			message: "Gratuita - Utenti registrati"
		})
	},
	{
		key: "SUBSCRIPTION",
		label: t({
			id: "const-stfc-subscription",
			message: "Solo utenti abbonati"
		})
	},
];
